<template>
  <div class="mx-auto mb-16 px-2">
    <TypeDisplay
      :variant="$options.Typography.Display.GIGA"
      :weight="$options.Typography.Weights.STRONG"
    >
      <p class="text-center mb-2" v-text="header"></p>
    </TypeDisplay>
    <TypeHeading
      v-if="subheader"
      :variant="$options.Typography.Heading.TITLE"
      :weight="$options.Typography.Weights.REGULAR"
    >
      <p class="text-center text-gray-3" v-text="subheader"></p>
    </TypeHeading>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { TypeDisplay, TypeHeading, constants } from '@bambeehr/pollen';

const { Typography } = constants;
export default defineComponent({
  name: 'FormattedHeader',
  Typography,
  components: {
    TypeDisplay,
    TypeHeading,
  },
  props: {
    header: {
      type: String,
      default: '',
    },
    subheader: {
      type: String,
      default: null,
    },
  },
  setup() {},
});
</script>
